import {ErrorMessage} from '../../../components/ErrorMessage/ErrorMessage';
import {useSurvey} from '../../../contexts/SurveyContext/SurveyContext';
import {PageHeader} from '../../../features/company/culture/surveys/components/PageHeader';
import {SurveyPaperWrapper} from '../../../features/company/culture/surveys/components/survey-details/SurveyPaperWrapper';
import {Survey} from '../../../features/company/culture/surveys/types/SurveyTypes';
import {Walkthrough} from '../../../features/walkthroughs';
import {companySurveysWalkthrough} from '../../../features/walkthroughs/steps/surveys';

export const CompanyCultureSurveys = () => {
  const {cultureSurveys, findCurrentSurvey, getPreviousSurvey, getUpcomingSurvey, loading, error} =
    useSurvey();

  const getPreviousCultureSurveys = (surveys: Survey[]) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return surveys
      .filter((survey) => {
        if (!survey.endedAt) return false;

        const endedAtDate = new Date(survey.endedAt);
        endedAtDate.setHours(0, 0, 0, 0);

        return endedAtDate <= today;
      })
      .sort((a, b) => {
        const endedAtA = a.endedAt ? new Date(a.endedAt).getTime() : 0;
        const endedAtB = b.endedAt ? new Date(b.endedAt).getTime() : 0;

        return endedAtB - endedAtA;
      });
  };

  if (error && !loading) {
    return <ErrorMessage />;
  }

  return (
    <>
      <PageHeader />
      <SurveyPaperWrapper
        loading={loading}
        upComingCultureSurvey={getUpcomingSurvey(cultureSurveys || [])}
        // NOTE: - Happiness part left out for the first version
        // upComingHappinessSurvey={getUpcomingSurvey(happinessSurveys || [])}

        currentCultureSurvey={findCurrentSurvey(cultureSurveys || [])}
        // NOTE: - Happiness part left out for the first version
        // currentHappinessSurvey={findCurrentSurvey(happinessSurveys || [])}

        previousCultureSurvey={getPreviousSurvey(cultureSurveys || [])}
        previousCultureSurveys={getPreviousCultureSurveys(cultureSurveys || [])}
        // NOTE: - Happiness part left out for the first version
        // previousHappinessSurvey={getPreviousSurvey(happinessSurveys || [])}
      />
      <Walkthrough definition={companySurveysWalkthrough} enabled={!loading} />
    </>
  );
};
